import airbnbLogo from '@/assets/icons/otas/airbnblogo.png';
import b2bReservasLogo from '@/assets/icons/otas/b2breservasLogo.svg';
import bookingLogo from '@/assets/icons/otas/bookinglogo.png';
import decolarLogo from '@/assets/icons/otas/decolarlogo.png';
import expediaLogo from '@/assets/icons/otas/expediaLogo.svg';
import homeawayLogo from '@/assets/icons/otas/homeawayLogo.svg';
import seazoneLogo from '@/assets/icons/otas/seazonelogo.png';
import staysLogo from '@/assets/icons/otas/staysIcon.webp';
import temporadalivreLogo from '@/assets/icons/otas/temporadalivreLogo.svg';
import testadorLogo from '@/assets/icons/otas/testadorLogo.svg';

export const ImageOta = {
  airbnb: airbnbLogo,
  booking: bookingLogo,
  decolar: decolarLogo,
  expedia: expediaLogo,
  homeaway: homeawayLogo,
  'website seazone': seazoneLogo,
  website: seazoneLogo,
  stays: staysLogo,
  temporadalivre: temporadalivreLogo,
  testador: testadorLogo,
  b2b: b2bReservasLogo,
} as const;
